/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect } from 'react';
import MaterialReactTable from 'material-react-table';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import _isEmpty from 'lodash/isEmpty';
import TableContainer from '@mui/material/TableContainer';
import { useDispatch, useSelector } from 'react-redux';
import Theme from '../ui/Theme';
import Service from '../../apis/service';
import { getTopicOfTheMonth, showProgress } from '../../redux/actions/DealershipActions';
import { ErrorToast } from '../utils/Utils';
import topicOfTheMonthDealershipColumns from './DealershipListTableColumns';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyles = makeStyles(() => ({
  primaryText: {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '20px',
    paddingLeft: '10px',
  },
  root: {
    backgroundColor: Theme.palette.secondary.main,
  },
  tableDiv: {
    marginLeft: '10px',
    marginRight: '10px',
    maxHeight: '72vh',
    height: '72vh',
    position: 'relative',
    zIndex: 0,
  },
}));

export default function TopicDealershipList() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const topicOfTheMonthDate = useSelector((state) => state.getTopicOfTheMonth.selectedDate);
  const topicOfTheMonthSelectedId = useSelector((state) => state.getTopicOfTheMonth.selectedTopicId);
  const topicOfTheMonthSelectedData = useSelector((state) => state.getTopicOfTheMonth.selectedTopicData);

  const fetchTopicDealershipList = async (topicId, topicDate) => {
    dispatch(showProgress(true));
    try {
      const response = await Service.post(apiEndpoints.TOM_TABLE, {
        date: topicDate,
        topicIds: topicId,
      });
      dispatch(getTopicOfTheMonth('SET_TOPIC_DATA', response));
    } catch (err) {
      ErrorToast(err);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (topicOfTheMonthSelectedId && !_isEmpty(topicOfTheMonthDate)) {
      fetchTopicDealershipList(topicOfTheMonthSelectedId.toString(), topicOfTheMonthDate.date);
    }
  }, [topicOfTheMonthSelectedId, topicOfTheMonthDate]);

  return (
    <div className={classes.root}>
      <Grid container alignItems="center" style={{ height: '48px' }}>
        <Typography className={classes.primaryText} noWrap>
          Topic - {topicOfTheMonthSelectedData?.topicName || ''}
        </Typography>
      </Grid>
      <div className={classes.tableDiv}>
        <TableContainer style={{ maxWidth: '75vw' }}>
          <MaterialReactTable
            columns={topicOfTheMonthDealershipColumns}
            data={topicOfTheMonthSelectedData?.dealerships || []}
            enableColumnActions
            enableColumnFilters
            enablePagination={false}
            enableSorting
            enableBottomToolbar={false}
            enableTopToolbar
            enableFullScreenToggle
            muiTableBodyRowProps={{ hover: true }}
            enableStickyHeader
            enableDensityToggle={false}
            enableMultiRowSelection={false}
            muiTableContainerProps={{ sx: { maxHeight: '65vh' } }}
          />
        </TableContainer>
      </div>
    </div>
  );
}
